export enum SuccessMessages {
  ResetPasswordValidEmail = 'An email with further instructions has been sent, be sure to check inbox and spam folder.',
  PasswordSuccessfullyReset = 'Password successfully reset.'
}
